export default __webpack_public_path__ + "static/media/bike.f416c961.svg";